import { FiFacebook, FiInstagram, FiMail, FiPhone } from 'react-icons/fi';
import { Flex, Link } from '@chakra-ui/react';

export const Socials = (props: any) => {
    return (
        <Flex alignItems="center" gap={3} mr={4} {...props}>
            <Link href="tel:+48513018199" color="orange.500" display="inline-flex" alignItems="center" _hover={{ color: 'gray.900', textDecoration: 'none' }}>
                <FiPhone />
            </Link>
            <Link href="mailto:sekretariat@opanuj.to" color="orange.500" display="inline-flex" alignItems="center" _hover={{ color: 'gray.900', textDecoration: 'none' }}>
                <FiMail />
            </Link>
            <Link href="http://www.facebook.com/Opanuj.To" target="_blank" rel="noreferrer" color="orange.500" display="inline-flex" alignItems="center" _hover={{ color: 'gray.900', textDecoration: 'none' }}>
                <FiFacebook />
            </Link>
            <Link href="https://www.instagram.com/opanuj.to/" target="_blank" rel="noreferrer" color="orange.500" display="inline-flex" alignItems="center" _hover={{ color: 'gray.900', textDecoration: 'none' }}>
                <FiInstagram />
            </Link>
        </Flex>
    )
};
